






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';

@Component({
  name: 'TrafficPanel',
  mixins: [MapResolver],
})
export default class TrafficPanel extends Vue {
  @Injectable() public container!: Container;

  private  datas: any = [
      {
          title: '严重拥堵',
          colorClass: 'level1',
      },
      {
          title: '拥挤',
          colorClass: 'level2',
      },
      {
          title: '缓行',
          colorClass: 'level3',
      },
      {
          title: '畅通',
          colorClass: 'level4',
      },
  ];
  private  timeData: any = '';
  constructor() {
    super();
  }

  private async  trafficCloseClick() {
      const component: any = await this.getComponent();
      component.removeTrfficLayer();
      this.$emit('trafficCloseClick');
  }

  private async refreshClick() {
     const component: any = await this.getComponent();
     component.removeTrfficLayer();
     component.addTafficLayer();
     this.timeData = this.getTimeData();
  }

  private getTimeData() {
      const tempTime: any = new Date();
      const hours: any = (tempTime.getHours()).toString().padStart(2, '0');
      const minutes: any = (tempTime.getMinutes()).toString().padStart(2, '0');
      return `${hours}:${minutes}`;
  }
  private created() {
     this.timeData = this.getTimeData();
  }


  private getComponent(moduleName: string = 'Toolbar', componentName: string = 'GISToolComponent') {
        const p = new Promise((resolve, reject) => {
            (this as any).resolveMap('map').then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName, componentName);
                resolve(component);
            }).catch(() => { reject('获取地图组件失败'); });
        });
        return p;
  }


}
